"use client"

import styles from "../../index.module.scss"
import { useSuffix } from "../../SuffixContext"
import { AdComponentTypes } from "../../types"
import { getPrefixCls } from "../../utils"

const prefixCls = getPrefixCls("ADComponent")

export default function TitleImg(props: AdComponentTypes) {
  const { AdList, style } = props
  const suffix = useSuffix()
  return (
    <div className={`${prefixCls} ${styles.tileImg}`} style={style}>
      <div className={`${styles.singleAdvModule} ${styles.advList}`}>
        <div className={styles.tileImgContainer}>
          <div
            className={styles.tileImgList}
            style={{
              width: AdList.len,
              height: AdList.width,
              overflow: "hidden",
            }}
          >
            <ul className={`${styles.list} ${styles.advBox}`}>
              {AdList.adverts?.map((item) => (
                <li key={item.id} data-sort={item.sort_score} className={styles.tileLi}>
                  <a href={item.link_url} target="_blank" rel="noreferrer">
                    <img src={`${item.pic_url}${suffix || ""}`} alt={item.name} />
                  </a>
                  {item.is_inner === 0 ? <div>AD</div> : null}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
